import FnrFetch3 from "Utilities/FnrFetch/FnrFetch3.js";

let API = {
  getPledges: ({ campaignID, startDate, endDate, dateType }) => {
    const params = new URLSearchParams({ campaignID });
    if (dateType !== undefined && dateType !== null) {
      params.append("dateType", dateType);
    }
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    return new FnrFetch3(
      `/giving/campaign/pledgeUsers?${params.toString()}`
    );
  },
  getCampaignData: ({ campaignID, userID }) => {
    const params = new URLSearchParams({ campaignID });
    if (userID !== undefined && userID !== null) {
      params.append("userID", userID);
    }
    return new FnrFetch3(`/giving/campaign/data?${params.toString()}`);
  },
};

export default API;
